/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('flow', [
  'getFlows',
  'countFlows',
]);


function getFlows(appId) {
  return createAPIAction(
    types.getFlows,
    {
      endpoint: '/lora/flows',
      query: {
        appid: appId,
      },
    },
  )();
}

function countFlows(query) {
  return createAPIAction(
    types.countFlows,
    {
      endpoint: '/lora/flows/count',
      query,
    },
  )();
}

export default {
  getFlows,
  countFlows,
};




// WEBPACK FOOTER //
// ./src/redux/actions/flow.js